import {
  Box,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { WebServiceLayerType } from "shared/common/stores/sidebarStore";

const QgisOptions = ({
  webServiceLayer,
  useOldConnection,
}: {
  webServiceLayer: WebServiceLayerType;
  useOldConnection: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 2,
        }}
      >
        <FormControl
          size="small"
          sx={{ width: { xs: "100%", md: "calc(60% - 8px)" } }}
        >
          <InputLabel>{t("add_layer.xhr_mode")}</InputLabel>
          <Select
            label="XHR Mode"
            defaultValue={
              (useOldConnection && webServiceLayer?.source_options?.xhr_mode) ||
              ""
            }
            onChange={(event) => {
              if (!webServiceLayer.source_options) {
                webServiceLayer.source_options = {};
              }
              webServiceLayer.source_options.xhr_mode = event.target.value;
            }}
          >
            <MenuItem value={"cors"}>{t("add_layer.xhr_mode_1")}</MenuItem>
            <MenuItem value={"no-cors"}>{t("add_layer.xhr_mode_2")}</MenuItem>
            <MenuItem value={"same-origin"}>
              {t("add_layer.xhr_mode_3")}
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
      <TextField
        label={t("add_layer.xhr_headers")}
        variant="outlined"
        defaultValue={
          (useOldConnection && webServiceLayer?.source_options?.xhr_headers) ||
          ""
        }
        size="small"
        multiline
        minRows={4}
        sx={{ width: { xs: "100%", md: "calc(60% - 8px)" } }}
        onChange={(event) => {
          if (!webServiceLayer.source_options) {
            webServiceLayer.source_options = {};
          }
          webServiceLayer.source_options.xhr_headers = event.target.value;
        }}
      />
      <FormControlLabel
        sx={{ width: "40%" }}
        control={
          <Switch
            defaultChecked={
              useOldConnection &&
              webServiceLayer.source_options?.withCredentials
                ? webServiceLayer.source_options.withCredentials
                : useOldConnection
                  ? false
                  : true
            }
          />
        }
        label={t("add_layer.switch_button_2")}
        onChange={(event, checked: boolean) => {
          if (!webServiceLayer.source_options) {
            webServiceLayer.source_options = {};
          }
          webServiceLayer.source_options.withCredentials = checked;
        }}
      />
    </Box>
  );
};
export default QgisOptions;
